import { IPhoneNumber } from '../../models/phone-number.model';
import { Component, Input, OnInit } from '@angular/core';
import { CountryInfo, ICountryInfo } from '../../models/phone-number-flag.model';

@Component({
    selector: 'app-phone-number',
    standalone: true,
    imports: [],
    templateUrl: './phone-number.component.html',
    styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnInit {
    @Input() phoneNumber: IPhoneNumber | undefined;
    countryInfo: ICountryInfo | undefined;

    ngOnInit(): void {
        this.countryInfo = CountryInfo.getCountryInfo(this.phoneNumber);
    }
}
